const NAME = 'SELECTED_ACCENTS'
export const UPDATE_VEST_ACCENTS = `${NAME}/UPDATE_VEST_ACCENTS`;
export const EDIT_VEST_ACCENTS = `${NAME}/EDIT_VEST_ACCENTS`;
// export const RESET_SELECTED_SUIT_ACCENTS = `${NAME}/RESET_SELECTED_SUIT_ACCENTS`;

export const getSelectedVestAccent = store => store[NAME].vest
export const updateSelectedVestAccent = (key, data) => {
    return {
        type: UPDATE_VEST_ACCENTS,
        key,
        data
    }
}

export const editSelectedVestAccent = (data) => {
    return {
        type: EDIT_VEST_ACCENTS,
        data
    }
}

// export const resetSelectedSuitAccent = (key) => {
//     return {
//         type: RESET_SELECTED_SUIT_ACCENTS,
//         key
//     }
// }